import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Container,
  Box,
  Flex,
  List,
  Text,
  Heading,
  Button,
  Input,
  CriteriaTag
} from "samba-ui";
import { NavLink } from "react-router-dom";
import "react-toggle/style.css";
import styled from "styled-components";
import Toggle from "react-toggle";
import "react-toggle/style.css";
import AreYouSureModal from "./AreYouSureModal";

import {
  loadAcrQueries,
  addNewAcrQuery,
  updateAcrQuery,
  deleteAcrQuery
} from "../redux/acrQueries";
import AddNewAcrQueryModal from "./AddNewAcrQueryModal";

const StyledLink = styled(NavLink)`
  text-decoration: none;
`;

const StyledInput = styled(Input)`
  width: 100%;
`;

const StyledFlex = styled(Flex)`
  opacity: ${p => (p.disabled ? 0.5 : 1)};
  pointer-events: {
    p=>p.disabled? "none" : "auto";
  }
`;

const ManageAcrQueries = ({
  acrQueries,
  loadAcrQueries,
  user,
  addNewAcrQuery,
  updateAcrQuery,
  deleteAcrQuery
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [selectedAcr, setSelectedAcr] = useState(null);
  const isSuperOperator = user.role === "superoperator";

  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  if (searchValue) {
    acrQueries = Object.keys(acrQueries)
      .filter(
        id =>
          acrQueries[id].name.toLowerCase().indexOf(searchValue.toLowerCase()) >
          -1
      )
      .reduce((acc, id) => {
        acc[id] = acrQueries[id];
        return acc;
      }, {});
  }

  useEffect(() => {
    const req = async () => {
      await loadAcrQueries();
    };
    req();
  }, [loadAcrQueries]);

  const onClose = () => {
    setIsOpen(false);
    setSelectedAcr(null);
  };

  const onUpdateClick = acr => {
    setIsOpen(true);
    setSelectedAcr(acr);
  };

  const onDeleteClick = acr => {
    setIsDeleteOpen(true);
    setSelectedAcr(acr);
  };

  const onDeleteModalClose = () => {
    setIsDeleteOpen(false);
    setSelectedAcr(null);
  };

  const getLink = params => {
    if (Object.keys(params).length) {
      return `/admin/acr-outages?${Object.keys(params)
        .map(key => key + "=" + params[key])
        .join("&")}`;
    }
  };

  return (
    <Container maxWidth={2048} minWidth={960}>
      <Flex>
        <Box width={3 / 4} mr={4}>
          <Flex mb={3}>
            <Heading color="secondary" fontSize={3} fontWeight={500}>
              ACR Queries
            </Heading>
          </Flex>
          <List.Header borderColor="#d6d6d6 !important">
            <Flex alignItems="center">
              <Box width={1 / 10}>
                <Text fontSize={1} color="secondary" fontWeight={500}>
                  Name
                </Text>
              </Box>
              <Box width={3 / 10}>
                <Text fontSize={1} color="secondary" fontWeight={500}>
                  Query
                </Text>
              </Box>
              <Box width={2 / 10}>
                <Text fontSize={1} color="secondary" fontWeight={500}>
                  Email List
                </Text>
              </Box>
              <Box width={1 / 10}>
                <Text fontSize={1} color="secondary" fontWeight={500}>
                  Created By
                </Text>
              </Box>
              <Box width={1 / 10} textAlign="right">
                <Text fontSize={1} color="secondary" fontWeight={500}>
                  Active
                </Text>
              </Box>
              <Box width={2 / 10} textAlign="right">
                <Button
                  variant="primaryBordered"
                  onClick={() => setIsOpen(true)}
                  disabled={isSuperOperator}
                >
                  + New Query
                </Button>
              </Box>
            </Flex>
          </List.Header>
          {!Object.keys(acrQueries).length ? (
            <List.Empty>No result found!</List.Empty>
          ) : null}
          {Object.keys(acrQueries).map(id => {
            return (
              <StyledLink key={id} to={getLink(acrQueries[id].query)}>
                <List.Item borderColor="#d6d6d6 !important">
                  <Flex alignItems="center">
                    <Box width={1 / 10}>
                      <Text>{acrQueries[id].name}</Text>
                    </Box>
                    <Box width={3 / 10}>
                      {Object.keys(acrQueries[id].query).map(key => {
                        return (
                          <Flex mb={2} key={key}>
                            <CriteriaTag> {key}</CriteriaTag>
                            <Box ml={2}>
                              <Text>{acrQueries[id].query[key]}</Text>
                            </Box>
                          </Flex>
                        );
                      })}
                    </Box>
                    <Box width={2 / 10} mr={2}>
                      {acrQueries[id].emailList.map(email => {
                        return (
                          <Box mb={1}>
                            <CriteriaTag>{email}</CriteriaTag>
                          </Box>
                        );
                      })}
                    </Box>
                    <Box width={1 / 10}>
                      <Text>
                        {acrQueries[id].createdBy
                          ? acrQueries[id].createdBy.replace("@samba.tv", "")
                          : ""}
                      </Text>
                    </Box>
                    <Box width={1 / 10} textAlign="right">
                      <Toggle checked={acrQueries[id].active} disabled />
                    </Box>
                    <StyledFlex
                      alignItems="center"
                      justifyContent="space-around"
                      width={2 / 10}
                      textAlign="right"
                      disabled={isSuperOperator}
                    >
                      <Button
                        variant="destructiveBordered"
                        onClick={e => {
                          e.preventDefault();
                          onDeleteClick(acrQueries[id]);
                        }}
                        disabled={isSuperOperator}
                      >
                        Delete
                      </Button>

                      <Button
                        variant="primaryBordered"
                        onClick={e => {
                          e.preventDefault();
                          onUpdateClick(acrQueries[id]);
                        }}
                        disabled={isSuperOperator}
                      >
                        Update
                      </Button>
                    </StyledFlex>
                  </Flex>
                </List.Item>
              </StyledLink>
            );
          })}
        </Box>
        <Box width={1 / 4} pt={5}>
          <Box mb={2}>
            <Text fontWeight={1} fontSize={0} color="palette.ink.light">
              Search queries
            </Text>
          </Box>
          <StyledInput
            placeholder="Search..."
            value={searchValue}
            onChange={e => setSearchValue(e.target.value)}
          />
        </Box>
      </Flex>
      <AddNewAcrQueryModal
        isOpen={isOpen}
        onClose={onClose}
        selectedAcr={selectedAcr}
        addNewAcrQuery={addNewAcrQuery}
        updateAcrQuery={updateAcrQuery}
      />
      <AreYouSureModal
        isOpen={isDeleteOpen}
        onClose={onDeleteModalClose}
        title="Delete Acr Query"
        body="Are you sure you want to delete this acr query?"
        onSubmit={() => {
          setIsDeleteOpen(false);
          deleteAcrQuery(selectedAcr.id);
        }}
      />
    </Container>
  );
};

ManageAcrQueries.propTypes = {
  acrQueries: PropTypes.object,
  user: PropTypes.object,
  loadAcrQueries: PropTypes.func,
  addNewAcrQuery: PropTypes.func,
  updateAcrQuery: PropTypes.func,
  deleteAcrQuery: PropTypes.func
};

const mapStateToProps = (state, props) => ({
  acrQueries: state.acrQueries
});

const mapDispatchToProps = dispatch => ({
  loadAcrQueries: query => dispatch(loadAcrQueries(query)),
  addNewAcrQuery: body => dispatch(addNewAcrQuery(body)),
  updateAcrQuery: (id, body) => dispatch(updateAcrQuery(id, body)),
  deleteAcrQuery: id => dispatch(deleteAcrQuery(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageAcrQueries);
